import "./header";
import "./faq";
import "./readMore";
import "./backToTop";

document.addEventListener("DOMContentLoaded", function (e) 
{
  const params = (new URL(window.location.toString())).searchParams;
  document.querySelectorAll("a").forEach(function (element) 
  {
    if (element.href.indexOf(window.location.host) !== -1) 
    {
      var urlParams = (new URL(element.href)).searchParams;

      urlParams.forEach(function (value, key)
      {
        if (!params.has(key)) {
          params.append(key, value);
        }
      });

      try {
        element.href = element.href.split('?')[0] + '?' + params.toString();
      } catch (e) {
        console.log(e);
      }
    }
  });
})